import React from "react";

import { Card } from "@/components/flowbite/card";
import IconButton from "@/components/flowbite/icon-button/icon-button";
import Typography from "@/components/flowbite/typography/typography";
import { DownloadIcon, EyeAltIcon } from "@/components/icons-lib";

interface FileCardProps {
  fileName: string;
  fileSizeBytes: number;
  onView?: () => void;
  onDownload?: () => void;
}

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${Math.round(bytes / Math.pow(k, i))} ${sizes[i]}`;
};

export const FileCard: React.FC<FileCardProps> = ({
  fileName,
  fileSizeBytes,
  onView,
  onDownload,
}) => {
  return (
    <Card className="flex min-w-0 items-center gap-2 overflow-hidden p-2.5 pl-3">
      <div className="flex min-w-0 flex-1 flex-col">
        <Typography.BodyMRegular
          capitalize={false}
          className="min-w-0"
          colorShade={400}
        >
          <span
            className="block truncate"
            title={fileName}
          >
            {fileName}
          </span>
        </Typography.BodyMRegular>
        <Typography.TableTitleXS colorShade={300}>
          {formatFileSize(fileSizeBytes)}
        </Typography.TableTitleXS>
      </div>

      <div className="flex shrink-0 gap-2">
        <IconButton
          icon={EyeAltIcon}
          variant="secondary"
          onClick={onView}
        />
        <IconButton
          icon={DownloadIcon}
          variant="secondary"
          onClick={onDownload}
        />
      </div>
    </Card>
  );
};
